export default {
      id: "crown-usage",
      viewBox: "0 0 412.67 278.1",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#crown",
      toString: function () {
        return this.url;
      }
    }